<template>
    <main-content>
        <action-bar>
            <router-link v-if="$can('manage', 'product')" :to="'/stores/'+store_hashid+'/products/create'" class="btn btn-success">{{ $t('product.btn.add') }}</router-link>
            <button class="back-btn ml-2" @click="$router.push('/stores')">
                {{ $t('label.back') }}<i class="pl-2 fa fa-arrow-left" style="color: white;"></i>
            </button>
        </action-bar>
        <filter-bar>
            // TODO
        </filter-bar>
        <kt-datatable v-bind="datatableProps"></kt-datatable>
    </main-content>
</template>

<script>
import { ApiUrl } from '@/common/api.service'
import columns from './datatable/columns'
import actions from './datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import goBackBtn from '@/components/custom/go-back-btn'
import actionBar from '@/components/custom/action-bar'
import filterBar from '@/components/custom/filter-bar'

export default {
    components: {
        mainContent,
        actionBar,
        filterBar
    },
    data() {
        return {
            headerAction: {
                left: '0',
                top: '10px',
                position: 'absolute'
            },
            store_hashid: this.$route.params.store_hashid
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "product_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('product'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions
            }
        }
    }
}
</script>

<style>

</style>